import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import { initAnalytics } from "./lib/analytics";
import Home from "./components/Home";
import About from "./components/About";
import AboutMarielle from "./components/AboutMarielle";
import FooterComponent from "./components/Footer";
import Projects from "./components/Projects";
import NavComponent from "./components/Nav";
import Contact from "./components/Contact";
import { AuthProvider } from "./components/WordyWhiz/context/AuthContext";
import Login from "./components/WordyWhiz/pages/Login";
import Signup from "./components/WordyWhiz/pages/Signup";
import PublicDictionaries from "./components/WordyWhiz/pages/PublicDictionaries";
import UserDictionaries from "./components/WordyWhiz/pages/UserDictionaries";
import DictionaryDetail from "./components/WordyWhiz/pages/DictionaryDetail";
import DictionaryStudy from "./components/WordyWhiz/pages/DictionaryStudy";
import Upload from "./components/WordyWhiz/pages/Upload";
import ManageAccount from "./components/WordyWhiz/pages/ManageAccount";
import Play from "./components/WordyWhiz/pages/Play";
import Stacks from "./components/WordyWhiz/pages/Stacks";
import "bootstrap/dist/css/bootstrap.min.css";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <div key={location.pathname} className="page-fade">
      <Routes location={location}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/about/marielle" element={<AboutMarielle />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/wordy-whiz/login" element={<Login />} />
        <Route path="/wordy-whiz/signup" element={<Signup />} />
        <Route path="/wordy-whiz/dictionaries" element={<PublicDictionaries />} />
        <Route path="/wordy-whiz/my-dictionaries" element={<UserDictionaries />} />
        <Route path="/wordy-whiz/dictionary/:id" element={<DictionaryDetail />} />
        <Route path="/wordy-whiz/study" element={<DictionaryStudy />} />
        <Route path="/wordy-whiz/play" element={<Play />} />
        <Route path="/wordy-whiz/stacks/:mode" element={<Stacks />} />
        <Route path="/wordy-whiz/stacks" element={<Navigate to="/wordy-whiz/stacks/classic" replace />} />
        <Route path="/wordy-whiz/upload" element={<Upload />} />
        <Route path="/wordy-whiz/account" element={<ManageAccount />} />
        <Route path="/wordy-whiz" element={<Navigate to="/wordy-whiz/dictionaries" />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
}

export default function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <Router>
      <AuthProvider>
        <NavComponent />
        <main style={{ minHeight: "calc(100vh - 64px - 88px)" }}>
          <AnimatedRoutes />
        </main>
        <FooterComponent />
      </AuthProvider>
    </Router>
  );
}
